export default __webpack_public_path__ + "static/media/banner-interviews.fb11413e.png";